import Marquee from "react-fast-marquee";

const PHRASES = [
  "Designing, building and running your India GCC",
  "Finance — Governance — Technology — Strategic Execution",
];

export default function EditorialMarquee() {
  return (
    <div
      className="overflow-hidden border-b border-line py-10 md:py-14"
      data-testid="editorial-marquee"
    >
      <Marquee speed={35} gradient={false}>
        {PHRASES.map((t) => (
          <span key={t} className="flex items-center">
            <span className="text-outline mx-8 font-serif text-4xl italic tracking-tight md:text-6xl">
              {t}
            </span>
            <span className="mx-4 h-2 w-2 bg-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
